<div class="bg-white p-5">
  <!-- Header bar -->
  <div class="page-title">
    <h1 class="text-xl font-bold text-dc-navy">
      {{ pageTitleKey | translate }}
    </h1>
    @if(payments && payments.length > 0){
    <div
      class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between"
    >
      <!-- <app-button
        classesName="card-edge-cut-white text-dc-navy w-full lg:w-auto"
        [label]="'SUCCESS_PAGE.DOWNLOAD_RECEIPT' | translate"
        (onBtnClick)="(false)"
      >
      </app-button> -->
      <app-button
        classesName="btn-edge-cut"
        [label]="'BUTTONS.EXPORT' | translate"
        (onBtnClick)="exportCSV()"
      >
      </app-button>
    </div>
    }
  </div>

  <!--Filter -->
  <form [formGroup]="filterForm" class="page-filterbar">
    @if (!isStatementsPage) {
    <div class="auto-width-dropdown w-full sm:w-60">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.SERVICE' | translate"
        [control]="filterForm.get('service')"
        [lovType]="lookupKey.DC_SR_TYPE"
        (onSelectionChange)="onServiceChange($event)"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [userType]="userType"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="auto-width-dropdown w-full sm:w-60">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.SUB_SERVICE' | translate"
        [control]="filterForm.get('subService')"
        [lovType]="lookupKey.SR_SUB_TYPE"
        (onSelectionChange)="applyFilter($event)"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [parentControl]="filterForm.get('service')"
        [parentLovType]="lookupKey.DC_SR_TYPE"
        [parentKey]="'Name'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="auto-width-dropdown w-full sm:w-60">
      <!-- need to send user csn no -->
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.USER' | translate"
        [options]="users"
        [labelKey]="'Name'"
        [valueKey]="'Value'"
        [control]="filterForm.get('user')"
        (onSelectionChange)="filterByUser($event)"
        [valueKey]="'CSN'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    }
     <div class="auto-width-dropdown w-full sm:w-60">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.DATE' | translate"
        [options]="dateRanges"
        [control]="filterForm.get('days')"
        (onSelectionChange)="onDayChnage($event)"
        [labelKey]="lang == 'en' ? 'Name' : 'NameAr'"
        [valueKey]="'Value'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    @if (isStatementsPage) {
  
    <div class="auto-width-dropdown w-full sm:w-60">
      <app-option-field
        label=""
        [placeholder]="'PAYMENTS.STATEMENT_COL.PAYMENT_METHOD' | translate"
        [control]="filterForm.get('paymentMethod')"
        (onSelectionChange)="applyFilter($event)"
        [options]="paymentMethodList"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    @if(showCustomDateRange){
        <div class="auto-width-dropdown w-full sm:w-60 mt-1">
          <div class="relative">
            <input
              type="text"
              class="calendar-field"
              [placeholder]="'PAYMENTS.FILTER.DATE_FROM' | translate"
              [value]="dateFromDisplay"
              readonly
              (click)="toggleDateCalendar('from')"
            />
            <button
              type="button"
              class="calendar-field-icon"
              (click)="toggleDateCalendar('from')"
            >
              <i class="fas fa-calendar"></i>
            </button>
            @if (dateFromDisplay) {
            <button
              type="button"
              class="calendar-field-clear"
              (click)="clearDateFrom($event)"
              aria-label="Clear date from"
            >
              <i class="fas fa-times"></i>
            </button>
            }
            @if (showDateFromCalendar) {
            <div class="absolute z-50 mt-2">
              <app-inline-calendar
                [selected]="selectedDateFrom || today"
                [disablePast]="false"
                [disableFuture]="true"
                (onDatePicked)="onDateFromPicked($event)"
              ></app-inline-calendar>
            </div>
            }
          </div>
        </div>
        <div class="auto-width-dropdown w-full sm:w-60 mt-1">
          <div class="relative">
            <input
              type="text"
              class="calendar-field"
              [placeholder]="'PAYMENTS.FILTER.DATE_TO' | translate"
              [value]="dateToDisplay"
              readonly
              (click)="toggleDateCalendar('to')"
            />
            <button
              type="button"
              class="calendar-field-icon"
              (click)="toggleDateCalendar('to')"
            >
              <i class="fas fa-calendar"></i>
            </button>
            @if (dateToDisplay) {
            <button
              type="button"
              class="calendar-field-clear"
              (click)="clearDateTo($event)"
              aria-label="Clear date to"
            >
              <i class="fas fa-times"></i>
            </button>
            }
            @if (showDateToCalendar) {
            <div class="absolute z-50 mt-2">
              <app-inline-calendar
                [selected]="selectedDateTo || today"
                [disablePast]="false"
                [disableFuture]="true"
                [minDate]="selectedDateFrom"
                [maxDate]="maxDateToSelection"
                (onDatePicked)="onDateToPicked($event)"
              ></app-inline-calendar>
            </div>
            }
          </div>
        </div>
      }
    }
   
  </form>

  @if (selectedRows && selectedRows.length > 0 && !isStatementsPage) {
  <div class="flex items-center gap-4 bg-[#E5F6FF] text-dc-navy py-4 px-4 mb-2 mt-2">
    <span class="font-semibold text-sm">
       {{ "MY_DOCS.SELECTED" | translate : { n: selectedRows.length } }}
    </span>
    <span class="ms-auto flex gap-5">
      <app-button
        classesName="card-edge-cut-white text-dc-navy"
        [label]="'SUCCESS_PAGE.DOWNLOAD_RECEIPT' | translate"
        (onBtnClick)="downloadReceipts()"
      />
    </span>
  </div>
  }
  <app-table
    [tableHeadings]="tableHeadings"
    [dataKeys]="tableDataKeys"
    [listData]="payments"
    [showActions]="showTableActions"
    [showPagination]="true"
    [showActionView]="false"
    [loader]="loader"
    [pageSize]="pageSize"
    [totalRecords]="totalRecords"
    [showActionMore]="showTableActionMore"
    [checkbox]="!isStatementsPage"
    [restrictSelectionByStatus]="false"
    [showActionPay]="showTableActionPay"
    (onView)="viewApp($event)"
    (onPageChange)="pageChange($event)"
    (onSelectRow)="selectRow($event)"
    (onPayClick)="gotoPaymentPage($event)"
  ></app-table>
</div>

<!-- payment detail modal -->
@if (paymentDetailModal) {
<div class="dc-modal">
  <div
    class="dc-modal-container p-6 bg-white rounded-xl shadow-lg max-w-4xl mx-auto"
  >
    <button
      class="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
      type="button"
      (click)="paymentDetailModal = false"
    >
      <i class="fas fa-close"></i>
    </button>

    <h1 class="text-2xl font-semibold mb-6 dc-text-navy">
      {{ "PAYMENTS.DETAIL" | translate }}
    </h1>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
      @for (field of invoiceFields; track $index) { @if(invoiceData[field.key]
      && field.key != "SR Created By Name"){
      <div>
        <label class="block font-bold text-dc-navy">
          {{ field.label | translate }}
        </label>
        <p class="text-dc-navy!">{{ invoiceData[field.key] || "—" }}</p>
      </div>
      } }
    </div>
  </div>
</div>
}
